import { Haptics as CapacitorHaptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

export class Haptics {
    impact = async () => {
        try{
            await CapacitorHaptics.impact({ style: ImpactStyle.Light });
        }
        catch(err){
            // fail silently if platform does not support haptics
        }
    };

    notification = async ({type }: { type: NotificationType }) => {
        try{
            await CapacitorHaptics.notification({ type });
        }
        catch(err){
            // fail silently if platform does not support haptics
        }
    };
};

export { NotificationType };
